module.exports = __webpack_public_path__ + "img/como-criar-widget-card.ec874d7c.jpg";